import { createSelector } from '@reduxjs/toolkit';

import { currentUserMaybeSelector } from '../selectors';
import { AffiliateUser } from '../../types/user';

import isUserAffiliate from './isUserAffiliate';

const getUserBalance = createSelector(
  currentUserMaybeSelector<AffiliateUser>,
  (user) => (user && isUserAffiliate(user) ? user.balance : 0),
);

export default getUserBalance;
